/*
 * @Author: 孙培国
 * @Date: 2024-08-07 15:01:39
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-02-19 09:31:55
 * @FilePath: \new-adminproject-frontend-h5\src\router\router.config.js
 */
/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    component: () => import('@/layouts/index'),
    redirect: '/home',
    meta: {
      title: '工作台',
      keepAlive: false
    },
    children: [
      {
        path: '/home',
        name: 'work',
        component: () => import('@/views/home'),
        meta: { title: '工作台', keepAlive: false }
      },
      {
        path: '/Information',
        name: 'Information',
        component: () => import('@/views/home/children/information'),
        meta: { title: '内部资讯', keepAlive: false }
      },
      {
        path: '/list',
        name: 'list',
        component: () => import('@/views/list'),
        meta: { title: '列表', keepAlive: false }
      },
      {
        path: '/registerList',
        name: 'registerList',
        component: () => import('@/views/registerList'),
        meta: { title: '注册', keepAlive: false }
      },
      {
        path: '/bingPhone',
        name: 'bingPhone',
        component: () => import('@/views/bingPhone'),
        meta: { title: '绑定', keepAlive: false }
      },
      {
        path: '/train',
        name: 'train',
        component: () => import('@/views/train'),
        meta: { title: '培训', keepAlive: false }
      },
      {
        path: '/venueReservation',
        name: 'venueReservation',
        component: () => import('@/views/venueReservation'),
        meta: { title: '场馆预约', keepAlive: false }
      },
      {
        path: '/venueReservationDetails',
        name: 'venueReservationDetails',
        component: () => import('@/views/venueReservation/details'),
        meta: { title: '场馆预约', keepAlive: false }
      },
      {
        path: '/venueReservationPersonalInformation',
        name: 'venueReservationPersonalInformation',
        component: () => import('@/views/venueReservation/children/personalInformation'),
        meta: { title: '个人信息', keepAlive: false }
      },
      {
        path: '/venueReservationPay',
        name: 'venueReservationPay',
        component: () => import('@/views/venueReservation/pay/index.vue'),
        meta: { title: '订单确认', keepAlive: false }
      },
      {
        path: '/paysuccess',
        name: 'paysuccess',
        component: () => import('@/views/venueReservation/pay/paysuccess.vue'),
        meta: { title: '支付成功', keepAlive: false }
      },
      {
        path: '/match',
        name: 'match',
        redirect: '/matchHome',
        component: () => import('@/layouts/index'),
        children: [
          {
            path: '/matchHome',
            name: 'matchHome',
            component: () => import('@/views/match/index.vue'),
            meta: { title: '赛事首页', keepAlive: false }
          },
          {
            path: '/matchDetails',
            name: 'matchDetails',
            component: () => import('@/views/matchDetails/index.vue'),
            meta: { title: '赛事详情', keepAlive: false }
          },
          {
            path: '/matchDetails-register',
            name: 'matchDetailsRegister',
            component: () => import('@/views/matchDetails/children/register.vue'),
            meta: { title: '赛事详情-个人报名', keepAlive: false }
          },
          {
            path: '/matchDetails-teamregister',
            name: 'matchDetailsTeamregister',
            component: () => import('@/views/matchDetails/children/teamregister.vue'),
            meta: { title: '赛事详情-团队报名', keepAlive: false }
          },
          {
            path: '/matchDetails-companyregister',
            name: 'matchDetailsCompanyregister',
            component: () => import('@/views/matchDetails/children/companyregister.vue'),
            meta: { title: '赛事详情-公司报名', keepAlive: false }
          },
          {
            path: '/matchDetails-fillInMemberInformation',
            name: 'matchDetailsFillInMemberInformation',
            component: () => import('@/views/matchDetails/children/fillInMemberInformation.vue'),
            meta: { title: '赛事详情-团队报名-填写成员信息', keepAlive: false }
          },
          {
            path: '/matchDetails-fillInLeaderMemberInformation',
            name: 'matchDetailsFillInLeaderMemberInformation',
            component: () => import('@/views/matchDetails/children/fillInLeaderMemberInformation.vue'),
            meta: { title: '赛事详情-团队报名-填写队长成员信息', keepAlive: false }
          },
          {
            path: '/matchDetails-registrationAgreement',
            name: 'matchDetailsRegistrationAgreement',
            component: () => import('@/views/matchDetails/children/registrationAgreement/index.vue'),
            meta: { title: '赛事详情-协议', keepAlive: false }
          },
          {
            path: '/matchDetails-signature',
            name: 'matchDetailsSignature',
            component: () => import('@/views/matchDetails/children/signature/index.vue'),
            meta: { title: '赛事详情-签名', keepAlive: false }
          },
          {
            path: '/matchDetails-pay',
            name: 'matchDetailsPay',
            component: () => import('@/views/matchDetails/children/pay/index.vue'),
            meta: { title: '赛事详情-支付', keepAlive: false }
          },
          {
            path: '/matchDetails-paySuccess',
            name: 'matchDetailsPaySuccess',
            component: () => import('@/views/matchDetails/children/PaySuccess/index.vue'),
            meta: { title: '赛事详情-支付成功', keepAlive: false }
          },
          {
            path: '/team',
            name: 'Team',
            redirect: '/team/teamHall',
            component: () => import('@/layouts/index'),
            children: [
              {
                path: '/team/teamHall',
                name: 'TeamHall',
                component: () => import('@/views/matchDetails/children/team/teamHall.vue'),
                meta: { title: '团队大厅', keepAlive: false }
              },
              {
                path: '/team/teamDetail',
                name: 'TeamDetail',
                component: () => import('@/views/matchDetails/children/team/teamDetail.vue'),
                meta: { title: '团队详情', keepAlive: false }
              },
              {
                path: '/team/joinTeam',
                name: 'JoinTeam',
                component: () => import('@/views/matchDetails/children/team/joinTeam.vue'),
                meta: { title: '加入团队', keepAlive: false }
              }
            ],
            meta: { title: '团队管理', keepAlive: false }
          },
          {
            path: '/notice',
            name: 'Notice',
            component: () => import('@/views/Notice/index.vue'),
            meta: { title: '赛事公告', keepAlive: false }
          },
          {
            path: '/notice-details',
            name: 'noticeDetails',
            component: () => import('@/views/noticeDetails/index.vue'),
            meta: { title: '赛事公告-详情', keepAlive: false }
          },
          {
            path: '/create-research-item',
            name: 'createResearchItem',
            component: () => import('@/views/createResearchItem/index.vue'),
            meta: { title: '创建调研事项', keepAlive: false }
          },
          {
            path: '/research-item-detail',
            name: 'researchItemDetail',
            component: () => import('@/views/researchItemDetail/index.vue'),
            meta: { title: '调研事项详情', keepAlive: false }
          },
          {
            path: '/research-items-demo',
            name: 'researchItemsDemo',
            component: () => import('@/views/matchDetails/children/researchItems/demo.vue'),
            meta: { title: '调研事项演示', keepAlive: false }
          },
          {
            path: '/research-progress',
            name: 'researchProgress',
            component: () => import('@/views/researchProgress/index.vue'),
            meta: { title: '参赛详情', keepAlive: false }
          },
          {
            path: '/create-research-item',
            name: 'createResearchItem',
            component: () => import('@/views/createResearchItem/index.vue'),
            meta: { title: '添加事项', keepAlive: false }
          },
          {
            path: '/upload-research',
            name: 'uploadResearch',
            component: () => import('@/views/uploadResearch/index.vue'),
            meta: { title: '上传调研', keepAlive: false }
          },
          {
            path: '/research-track',
            name: 'researchTrack',
            component: () => import('@/views/researchTrack/index.vue'),
            meta: { title: '调研轨迹', keepAlive: false }
          }
        ],
        meta: { title: '赛事', keepAlive: false }
      }
    ]
  },
  {
    path: '/informationDetail',
    name: 'informationDetail',
    component: () => import('@/views/home/children/informationDetail'),
    meta: { title: '内部资讯详情', keepAlive: false }
  },
  {
    path: '/unitRegistration',
    name: 'unitRegistration',
    component: () => import('@/views/unitRegistration'),
    meta: { title: '单位会员', keepAlive: false }
  },
  {
    path: '/peopleRegistration',
    name: 'peopleRegistration',
    component: () => import('@/views/peopleRegistration'),
    meta: { title: '个人', keepAlive: false }
  },
  {
    path: '/peopleRegistration',
    name: 'peopleRegistration',
    component: () => import('@/views/peopleRegistration'),
    meta: { title: '个人', keepAlive: false }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
    meta: { title: '登录', keepAlive: false }
  },

  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register'),
    meta: { title: '注册', keepAlive: false }
  },

  {
    path: '/haveAccount',
    name: 'haveAccount',
    component: () => import('@/views/haveAccount'),
    meta: { title: '登录', keepAlive: false }
  },
  {
    path: '/idcarNumber',
    name: 'idcarNumber',
    component: () => import('@/views/list/component/idcarNumber'),
    meta: { title: '身份认证', keepAlive: false }
  },
  {
    path: '/set',
    name: 'set',
    component: () => import('@/views/list/component/set'),
    meta: { title: '个人资料设置', keepAlive: false }
  },
  {
    path: '/myOrder',
    name: 'myOrder',
    component: () => import('@/views/list/component/myOrder.vue'),
    meta: { title: '我的订单', keepAlive: false }
  },
  {
    path: '/myWriteoff',
    name: 'myWriteoff',
    component: () => import('@/views/list/component/myWriteoff.vue'),
    meta: { title: '核销订单', keepAlive: false }
  },
  {
    path: '/myOrder_details',
    name: 'myOrderDetails',
    component: () => import('@/views/list/component/myOrder_details.vue'),
    meta: { title: '订单详情', keepAlive: false }
  },
  {
    path: '/myWriteoff_details',
    name: 'myWriteoffDetails',
    component: () => import('@/views/list/component/myWriteoff_details.vue'),
    meta: { title: '核销订单详情', keepAlive: false }
  },
  {
    path: '/points',
    name: 'points',
    component: () => import('@/views/list/component/points'),
    meta: { title: '我的积分', keepAlive: false }
  },

  {
    path: '/myTournament',
    name: 'myTournament',
    component: () => import('@/views/list/component/myTournament'),
    meta: { title: '我的赛事活动', keepAlive: false }
  },
  {
    path: '/myTournamentTeam',
    name: 'myTournamentTeam',
    component: () => import('@/views/list/component/myTournamentTeam'),
    meta: { title: '我的赛事活动', keepAlive: false }
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/list/component/detail'),
    meta: { title: '赛事详情', keepAlive: false }
  },
  {
    path: '/teamDetail',
    name: 'teamDetail',
    component: () => import('@/views/list/component/teamDetail'),
    meta: { title: '赛事详情', keepAlive: false }
  },

  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('@/views/list/component/certificate'),
    meta: { title: '我的证书', keepAlive: false }
  },
  {
    path: '/unitregister',
    name: 'unitregister',
    component: () => import('@/views/unitRegistration/components/register.vue'),
    meta: { title: '公司会员注册', keepAlive: false }
  },
  {
    path: '/peopleRegistrationregiste',
    name: 'peopleRegistrationregiste',
    component: () => import('@/views/peopleRegistration/components/register.vue'),
    meta: { title: '个人会员注册', keepAlive: false }
  },
  {
    path: '/traindetail',
    name: 'traindetail',
    component: () => import('@/views/train/component/traindetail.vue'),
    meta: { title: '报名详情', keepAlive: false }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/views/train/component/signup.vue'),
    meta: { title: '报名', keepAlive: false }
  },
  {
    path: '/trainList',
    name: 'trainList',
    component: () => import('@/views/trainList'),
    meta: { title: '报名', keepAlive: false }
  },
  {
    path: '/apply-research-letter',
    name: 'applyResearchLetter',
    component: () => import('@/views/applyResearchLetter/index.vue'),
    meta: { title: '申请调研函', keepAlive: false }
  }
]
